import type { IconSvgObject } from './types';

const Napkins02Icon: IconSvgObject = [
  ["path", { d: "M18 12L12 2L6 12L12 18L18 12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16.5 9.5L12 14L7.5 9.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16.5 13.5L18 16L12 22L6 16L7.5 13.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Napkins02Icon;
